import ApplicationSerializer from '@square/dashboard-data/serializers/application';
import { MerchantImagePurposes } from '@square/dashboard-data/models/legacy/merchant-image';
import { v4 as uuid } from 'uuid';
export default ApplicationSerializer.extend({
  attrs: {
    file: 'image'
  },
  extractId(modelClass, resourceHash) {
    if (!resourceHash['image_purpose'] || !resourceHash['content_digest']) {
      return null;
    }

    // For CT2 background images, use a UUID to allow for duplicates.
    // Using the other properties does not guarantee uniqueness.
    // This is limited to a specific image purpose to reduce the scope of this change.
    const imagePurpose = resourceHash['image_purpose'];
    if (imagePurpose === MerchantImagePurposes.BUYER_FACING_DISPLAY_ON_TERMINAL) {
      return uuid();
    }
    return `${resourceHash['image_purpose']}_${resourceHash['content_digest']}_${resourceHash['user_token']}`;
  },
  serializeAttribute(snapshot, json, key, attribute) {
    if (key === 'imagePurpose') {
      if (snapshot.attr('requestImagePurpose')) {
        // eslint-disable-next-line no-param-reassign
        json['image_purpose'] = snapshot.attr('requestImagePurpose');
      } else {
        // eslint-disable-next-line no-param-reassign
        json['image_purpose'] = snapshot.attr('imagePurpose') || MerchantImagePurposes.BUYER_FACING_DISPLAY;
      }
      return;
    }
    this._super(snapshot, json, key, attribute);
  },
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (requestType === 'createRecord') {
      if ('entities' in payload) {
        // eslint-disable-next-line no-param-reassign
        payload = payload.entities[payload.entities.length - 1];
      }
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});